export const translationLivechat_en_part3 = {
  livechatAvatarUploading: "Uploading...",
  livechatAvatarUploaded: "Image uploaded",
  livechatAvatarUploadFailed: "Upload failed",
  livechatDisplayNameRequired: "Display name is required.",
  livechatSaveProfile: "Save profile",
  livechatSaving: "Saving...",
  livechatClose: "Close",
  livechatCancel: "Cancel",
  livechatSettingsModalTitleLive: "Live environment livechat settings",
  livechatSettingsModalTitleTest: "Test environment livechat settings",
  livechatSettingsModalEyebrow: "{chatbotId} · {env} environment",
  livechatSettingsLoading: "Loading settings...",
  livechatSettingsWebhook: "Webhook",
  livechatSettingsEnabledByAdmin: "Enabled by admin",
  livechatSettingsDisabledByAdmin: "Disabled by admin",
  livechatSettingsConfigured: "Configured",
  livechatSettingsNotConfigured: "Not configured",
  livechatSettingsUnavailable: "Unavailable",
  livechatSettingsAttachmentRetention: "Attachment retention days",
  livechatSettingsTimezone: "Working hours timezone",
  livechatSettingsManualAvailability: "Availability mode",
  livechatSettingsManualAuto: "Follow working hours",
  livechatSettingsManualLive: "Always online",
  livechatSettingsManualOffline: "Always offline",
  livechatSettingsTranslationMode: "Livechat translation",
  livechatSettingsTranslationOff: "Off",
  livechatSettingsTranslationManual: "Visitor can translate",
  livechatSettingsTranslationAuto: "Auto translate",
  livechatSettingsTranslationHelp:
    "Applies only to agent messages in the chatbot. Auto translation uses the conversation's AI-detected language and falls back to the chatbot language.",
  livechatSettingsShowLogo: "Show the livechat button in the chat title bar",
  livechatSettingsShowLogoHelp: "The headset button visitors use to open the livechat.",
  livechatSettingsHideHeaderButtonLabel: "Let visitors start a livechat from the button",
  livechatSettingsHideHeaderButtonHelp:
    "When off, visitors cannot start a livechat from the title bar themselves. AI-triggered handoffs and contact forms with livechat still work, and the button appears during an active livechat so it can be ended.",
  livechatSettingsWorkingHours: "Working hours",
  livechatSettingsAddHours: "Add hours",
  livechatSettingsNoHours: "No hours",
  livechatSettingsRemove: "Remove",
  livechatSettingsSave: "Save settings",
  livechatSettingsSaving: "Saving...",
  livechatSettingsRetentionInteger: "Attachment retention days must be an integer.",
  livechatWeekdayMonday: "Monday",
  livechatWeekdayTuesday: "Tuesday",
  livechatWeekdayWednesday: "Wednesday",
  livechatWeekdayThursday: "Thursday",
  livechatWeekdayFriday: "Friday",
  livechatWeekdaySaturday: "Saturday",
  livechatWeekdaySunday: "Sunday",
  livechatAvailabilityDisabled: "Disabled",
  livechatAvailabilityManualLive: "Set online manually",
  livechatAvailabilityManualOffline: "Set offline manually",
  livechatAvailabilityAlwaysOn: "No working hours set, always online",
  livechatAvailabilityWithinHours: "Within working hours",
  livechatAvailabilityOutsideHours: "Outside working hours",
  livechatEnvironmentWordLive: "Live",
  livechatEnvironmentWordTest: "Test",
  livechatRelativeJustNow: "just now",
  livechatRelativeSecondsAgo: "{count}s ago",
  livechatRelativeMinutesAgo: "{count}m ago",
  livechatRelativeHoursAgo: "{count}h ago",
  livechatRelativeDaysAgo: "{count}d ago",
  livechatDurationSeconds: "{count}s",
  livechatDurationMinutes: "{count}m",
  livechatDurationHoursMinutes: "{hours}h {minutes}m",
  livechatDurationHours: "{count}h",
  livechatDurationDays: "{count}d",
  livechatWaitingForLabel: "Waiting",
  livechatActiveForLabel: "Active",
  livechatClosedAgoLabel: "Closed",
  livechatVisitorTitleFallback: "Visitor",
  livechatNewBadge: "New",
  livechatComposerKeyboardHint: "Enter to send · Shift+Enter for a new line",
  livechatRemoveAttachment: "Remove attachment",
  livechatAttachFiles: "Attach files",
  livechatInsertEmoji: "Insert emoji",
  livechatNoSessionTipsTitle: "No session selected",
  livechatNoSessionTipsHint:
    "Pick a session from the list on the left, or switch tabs to view waiting, active, or closed conversations.",
  livechatNoSessionsHeadline: "All quiet here",
  livechatNoSessionsHintWaiting:
    "No customers are waiting right now. New conversations will appear automatically.",
  livechatNoSessionsHintActive:
    "You have no active conversations. Switch to Waiting to pick one up.",
  livechatNoSessionsHintClosed: "No closed conversations yet under this filter.",
  livechatNoSessionsHintDefault: "No sessions match the selected filters.",
  livechatNoSearchResultsHeadline: "No matches",
  livechatNoSessionsHintSearch:
    'No conversations match "{query}" under this filter. Try another term or switch tabs.',
  livechatSearchSessionsPlaceholder: "Search conversations, IDs, visitors or customer data...",
  livechatSearchSessionsAria: "Search livechat conversations",
  livechatSearchMatchLabel: "Search match",
  livechatClearSearch: "Clear search",
  livechatHeaderAvailabilityLabel: "Availability",
  livechatHeaderAvailabilityLive: "Online",
  livechatHeaderAvailabilityOffline: "Offline",
  livechatHeaderAvailabilityLoading: "Loading…",
  livechatAvailabilityToggleLabel: "Set livechat online or offline for {chatbotId}",
  livechatAvailabilityToggleHint:
    "Manual override. Choose “Follow working hours” in Settings to use the schedule instead.",
  livechatHeaderEnvLabel: "Environment",
  livechatHeaderChatbotLabel: "Chatbot",
  livechatVisitorOtherSessionsCount: "{count} more sessions from this visitor",
  livechatVisitorOtherSessionsCountSingular: "1 more session from this visitor",
  livechatHideOtherSessions: "Hide",
  livechatShowOtherSessions: "Show all",
  livechatLastUpdated: "Last updated",
  livechatSettingsButton: "Settings",
  livechatSettingsForChatbot: "Livechat settings for {chatbotId}",
  livechatSettingsChooseChatbot: "Choose which chatbot to configure",
  livechatSettingsNoChatbots: "No chatbots available",
  livechatSettingsSectionAvailability: "Availability",
  livechatSettingsSectionAvailabilityHelp:
    "Controls when visitors can start a livechat with this chatbot.",
  livechatSettingsManualAvailabilityHelp:
    "Follow working hours uses the schedule below. Always online or Always offline overrides it until you change it again.",
  livechatSettingsWorkingHoursHelp:
    "Livechat is online in these time slots while following working hours.",
  livechatSettingsWorkingHoursIgnored:
    "Working hours are not used while availability is set to Always online or Always offline.",
  livechatSettingsSectionWidget: "Chat widget",
  livechatSettingsSectionWidgetHelp: "How visitors get to the livechat from the chatbot.",
  livechatSettingsSectionTranslation: "Translation",
  livechatSettingsSectionData: "Data retention",
  livechatSettingsAttachmentRetentionHelp:
    "Files uploaded in livechats are deleted after this many days.",
  livechatSettingsWorkingHoursNoneSet:
    "No hours set: livechat is online around the clock. Add hours to restrict it.",
  livechatSettingsSlotInvalid: "Each working-hours slot needs an end time after its start time.",
  livechatFilterHint: "Filter conversations by chatbot",
  livechatFilterSelectedOfTotal: "{count} of {total} chatbots",
  livechatFilterAllInScope: "All chatbots in {scope}",
  livechatFilterSearchPlaceholder: "Search chatbots…",
  livechatFilterNoMatches: "No chatbots match your search.",
  livechatFilterOnly: "Only",
  livechatFilterOnlyChatbot: "Only {chatbot}",
  livechatVerifiedMetadata: "Verified customer data",
  livechatVerifiedMetadataHint:
    "Signed by the customer's website and verified by us, so it can be trusted.",
  livechatRoutedTo: "Routed to",
  livechatAcceptedBy: "Accepted by",
  livechatGroupsButton: "Groups",
  livechatGroupsTitle: "Livechat groups",
  livechatGroupsDescription:
    'Groups are teams of agents a contact form can route chats to, e.g. "Back Office". Members are resolved when a chat arrives, so you can change the roster daily. Groups are shared across all chatbots in the organization.',
  livechatGroupsEmpty: "No groups yet. Create one to route contact form chats to a team.",
  livechatGroupsNew: "New group",
  livechatGroupsLoadFailed: "Could not load groups.",
  livechatGroupName: "Group name",
  livechatGroupNamePlaceholder: "Back Office",
  livechatGroupNameRequired: "Give the group a name.",
  livechatGroupMembers: "Members",
  livechatGroupMembersCount: "{count} members",
  livechatGroupMembersOne: "1 member",
  livechatGroupNoCandidates: "No users found in the organization.",
  livechatGroupUnknownMember: "Unknown user (no longer in the organization)",
  livechatGroupSave: "Save group",
  livechatGroupCreate: "Create group",
  livechatGroupDelete: "Delete group",
  livechatGroupDeleteConfirm:
    "Delete this group? Forms routing to it fall back to the general queue.",
  livechatGroupSaveFailed: "Could not save the group.",
  livechatGroupDeleteFailed: "Could not delete the group.",
  livechatGroupNameTaken: "A group with this name already exists.",
  livechatGroupsClose: "Close",
  livechatGroupsSelectHint: "Select a group to edit its name and members.",
  livechatRoutingTimeLeft: "{time} left for the routed agents",
  livechatRoutingFallbackTimeout: "no reply from the routed agents, open to everyone",
  livechatRoutingFallbackNoOnline: "nobody routed was online, open to everyone",
  livechatRoutingFallbackNoAgents: "no routed agent has a livechat profile here, open to everyone",
  livechatSettingsSectionRouting: "Routed chats",
  livechatSettingsSectionRoutingHelp:
    "Contact forms can route chats to a livechat group. While at least one member is online, only the group sees the chat; after the timeout it opens to everyone. This setting applies to the whole organization.",
  livechatSettingsRoutingTimeout: "Fall back to everyone after (minutes)",
  livechatSettingsRoutingTimeoutHelp:
    "How long a routed chat waits for the group before every agent sees it. 1 to 60 minutes, default 3.",
  livechatSettingsRoutingTimeoutInvalid:
    "The routing timeout must be a whole number between 1 and 60.",
  livechatBulkHoursTitle: "Apply opening hours to multiple chatbots",
  livechatBulkHoursHelp:
    "Copy the opening hours and timezone shown above. Other unsaved settings are not included.",
  livechatBulkHoursTargets: "Select chatbots",
  livechatBulkHoursClear: "Clear selection",
  livechatBulkHoursSelectAll: "Select all",
  livechatBulkHoursPreview: "Replace opening hours on {count} chatbots",
  livechatBulkHoursPreserve:
    "Manual availability overrides remain in effect. Disabled chatbots stay disabled. Other settings are unchanged.",
  livechatBulkHoursFailed: "Could not confirm the update. Check the settings before retrying.",
  livechatBulkHoursSaved: "Opening hours applied to the selected chatbots.",
  livechatBulkHoursApply: "Apply to {count} chatbots",
  livechatBulkHoursReview: "Review selected chatbots",
  livechatBulkHoursTargetsFailed:
    "Could not load chatbots for the active organization. Close and reopen this section to retry.",
};
